import { Sentry } from '@/app';
import { i18n } from '@/i18n';
import { USER_TYPE } from '@/typings/enums/USER_TYPE';
import { useModal } from '@orion.ui/orion';
import { RouteRecordRaw, createRouter, createWebHistory } from 'vue-router';
import routesAgency from './agency.router';
import routesClient from './client.router';
import routesLogin from './login.router';
import routesTempWorker from './tempWorker.router';

const userType = localStorage.getItem('userType');

const routes = [
	...routesLogin,
	{
		path: '/signup',
		name: 'Signup',
		component: () => import('@/components/signup/SignupView.vue'),
		meta: {
			browserTitleKey: 'common.page.registration',
			descriptionKey: 'auth.login.createAccount',
		},
	},
	{
		path: '/code-agence',
		name: 'OnboardingAgencyCompanyCode',
		component: () => import('@/components/onboarding/OnboardingCodeScanView.vue'),
		meta: { browserTitleKey: 'common.page.agencyCode' },
	},
	{
		path: '/',
		name: 'Home',
		component: () => import('@/components/shared/SharedLayout.vue'),
		meta: { requiresAuth: true },
		children: [
			{
				path: '',
				name: 'Dashboard',
				component: () => import('@/components/dashboard/DashboardView.vue'),
			},
			/*
			{
				path: 'aide-en-ligne',
				name: 'Help',
				component: Help,
			},
		], */
		],
	},
	{
		path: '/signature-statut/:status',
		name: 'Signature statut',
		component: () => import('@/components/yousign/YousignSignatureStatus.vue'),
		props: true,
	},
	{
		path: '/legal',
		name: 'Legal',
		component: () => import('@/components/legal/LegalView.vue'),
		meta: { browserTitleKey: 'common.page.legalPolicies' },
	},
	{
		path: '/impersonate',
		name: 'Impersonate',
		component: () => import('@/components/ImpersonateView.vue'),
	},
	{
		path: '/:pathMatch(.*)*',
		name: 'Redirect',
		redirect: { name: 'Dashboard' },
	},
] as const;

const router = createRouter({
	history: createWebHistory(),
	routes: routes as unknown as RouteRecordRaw[],
});

if (userType) addRoutes(+userType);

export function addRoutes (userType: USER_TYPE) {
	switch (Number(userType)) {
		case USER_TYPE.TempWorker:
			routesTempWorker.forEach((x) => {
				router.addRoute(x as unknown as RouteRecordRaw);
			});
			break;
		case USER_TYPE.Agency:
			routesAgency.forEach((x) => {
				router.addRoute(x as unknown as RouteRecordRaw);
			});
			break;
		case USER_TYPE.Client:
			routesClient.forEach((x) => {
				router.addRoute(x as unknown as RouteRecordRaw);
			});
			break;
	}
}

router.beforeEach((to, from, next) => {
	const browserTitle = to.meta.browserTitleKey
		? i18n.global.t(to.meta.browserTitleKey as string)
		: undefined;
	document.title = browserTitle ? `Armado - ${browserTitle}` : 'Armado';
	const description = to.meta.descriptionKey
		? i18n.global.t(to.meta.descriptionKey as string)
		: i18n.global.t('common.meta.description');
	document?.querySelector('meta[name="description"]')?.setAttribute('content', description);
	return next();
});

router.onError((error) => {
	if (/chunk/.test(error.message) || /dynamically imported module/.test(error.message)) {
		Sentry.captureException(error);

		useModal({
			size: 'xs',
			hideOnOverlayClick: false,
			hideOnEsc: false,
			hideClose: true,
			title: i18n.global.t('documents.signature.status.error'),
			message: i18n.global.t('common.error.newVersionAvailable', { br: '<br>', strong: '<strong>', '/strong': '</strong>' }),
			actions: [
				{
					label: i18n.global.t('common.page.reload'),
					color: 'brand',
					callback: () => {
						setTimeout(() => {
							window.location.reload();
						}, 500);
						throw `Post MEP - Reload page`;
					},
				},
			],
		});
	}
});

export default router;
